// extracted by mini-css-extract-plugin
module.exports = {"modal_container":"ModalCustom_modal_container__5WLxn","modal_bg":"ModalCustom_modal_bg__PpdO_","modal":"ModalCustom_modal__hxrn_"};